
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/[section]",
      function () {
        return require("private-next-pages/articles/[section].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/[section]"])
      });
    }
  